import React from 'react'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import { ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP } from '@/modules/economicAsset/constants'

interface GetLabelContentProps {
  type: 'vat' | 'comments' | 'priceGross';
  classes: any;
  lang: any;
  typeLabel?: string;
}

const GetLabelContent: React.FC<GetLabelContentProps> = ({ type, classes, lang, typeLabel }) => {
  const isTransferToPrivate = typeLabel === ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.TRANSFER_TO_PRIVATE_OWNERSHIP
  const tooltipData: Record<string, { label: string, tooltips: string[] }> = {
    vat: {
      label: lang.economicAsset.bookingModal.vatSelectInputLabel,
      tooltips: isTransferToPrivate
        ? [lang.economicAsset.bookingModal.vatTooltipPrivateTransfer]
        : [lang.economicAsset.bookingModal.vatTooltip1, lang.economicAsset.bookingModal.vatTooltip2],
    },
    comments: {
      label: lang.economicAsset.bookingModal.notesLabel,
      tooltips: [lang.economicAsset.bookingModal.notesTooltip1, lang.economicAsset.bookingModal.notesTooltip2, lang.economicAsset.bookingModal.notesTooltip3],
    },
    priceGross: {
      label: isTransferToPrivate
        ? lang.economicAsset.bookingModal.pricePrivateTransferLabel
        : lang.economicAsset.bookingModal.priceLabel,
      tooltips: isTransferToPrivate
        ? [lang.economicAsset.bookingModal.priceTooltipPrivateTransfer]
        : [lang.economicAsset.bookingModal.priceTooltip1, lang.economicAsset.bookingModal.priceTooltip2],
    },
  }

  const { label, tooltips } = tooltipData[type] || { label: '', tooltips: [] }

  return (
    <div className={classes.notesContent}>
      <span>{label}</span>
      <RichTooltip
        content={(
          <div className={classes.notesTooltip}>
            {tooltips.map((tooltip, index) => (
              <span key={index}>{tooltip}</span>
            ))}
          </div>
        )}
        placement='bottom'
        width={300}>
        <div className={classes.notesInfo}>
          <div className={classes.notesInfoWrapper}>i</div>
        </div>
      </RichTooltip>
    </div>
  )
}

export default GetLabelContent
